webpackJsonp([1],{

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(84)

var Component = __webpack_require__(40)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(91),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Idea__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Idea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Idea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_twitter_logo_svg__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_twitter_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_twitter_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_insta_svg__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_insta_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_insta_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_github_svg__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_github_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_github_svg__);







function addRef(link) {
  return link + '/?ref=' + encodeURIComponent(window.location.href);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      imgs: {
        twitter: __WEBPACK_IMPORTED_MODULE_1__assets_twitter_logo_svg___default.a,
        insta: __WEBPACK_IMPORTED_MODULE_2__assets_insta_svg___default.a,
        gh: __WEBPACK_IMPORTED_MODULE_3__assets_github_svg___default.a
      },
      mccallLink: addRef("https://mccallalexander.com"),
      stefanLink: addRef("http://steppot.com"),
      michalLink: addRef("https://dribbble.com/mikkimikki"),
      audreyLink: addRef("https://thenounproject.com/andvasiliev"),
      nounProjLink: addRef("https://thenounproject.com"),
      home: '' + window.location.href
    };
  },

  components: { Idea: __WEBPACK_IMPORTED_MODULE_0__components_Idea___default.a }
});

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_twitter_svg__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_twitter_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_twitter_svg__);






function randomItem(arr) {
  var randomIndex = ~~(Math.random() * arr.length);
  return arr[randomIndex];
}

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      job: '',
      action: '',
      tech: '',
      defaultCols: 4,
      btnstyle: {},
      twitterLogo: __WEBPACK_IMPORTED_MODULE_2__assets_twitter_svg___default.a,
      fullSentence: ''
    };
  },

  methods: {
    mixup: function mixup() {
      var _this = this;

      this.btnstyle = {
        transform: 'scale(1.1)'
      };
      var t = setTimeout(function () {
        _this.btnstyle = {
          transform: 'scale(1)'
        };
      }, 150);

      this.job = randomItem(__WEBPACK_IMPORTED_MODULE_0__data__["a" /* jobs */]);
      this.tech = randomItem(__WEBPACK_IMPORTED_MODULE_0__data__["b" /* tech */]);
      this.action = randomItem(__WEBPACK_IMPORTED_MODULE_0__data__["c" /* actions */]);
    }
  },
  computed: {
    twitterIntent: function twitterIntent() {
      return 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(this.fullSentence) + '&url=' + encodeURIComponent(window.location.href) + '&via=mccallthetall';
    }
  },
  updated: function updated() {
    this.fullSentence = '"' + document.getElementById('idea').innerText + ',"';
  },
  beforeMount: function beforeMount() {
    this.mixup();
  }
});

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return jobs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return actions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tech; });


var jobs = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(["fire fighters", "police officers", "software engineers", "web developers", "plumbers", "welders", "painters", "soldiers", "hair dressers", "mechanical engineers", "UX designers", "politicians", "activists", "social media stars", "high schoolers", "teachers", "college students", "microbiologists", "physicians", "secretaries", "basketball players", "triathletes", "mechanics", "advertisers", "recruiters", "nurses", "retirees", 'farmers', 'people learning to code', 'conservation officers', 'construction workers', 'field workers', 'horse trainers', 'landscapers', 'contractors', 'renters', 'land lords', 'startup founders', 'photographers', 'the homeless', 'refugees', "moms", "dads", "kindergarteners", "middle schoolers", "high schoolers", "hunters", "product managers", "data scientists", "evolutionary psychologists", "angel investors", "pharmacists", "chefs", "astronomers", "dogs", "cats", "pregnant women", "women", "men", "girls in STEM", "vegetarians", "social media managers"])));

var actions = ["meet for lunch", "keep track of time", "set personal goals", "communicate better", 'relax', 'sleep better', 'eat healthier', 'learn new things', 'save time', 'pay bills', 'build a portfolio', 'be more efficient', "network", "go outside more often", "shop", "start small businesses", "make meals", "study", "find interesting articles", "exercise", "meet new friends", "organize their workspace", "find jobs", "find useful tech", "make money", "take care of their pets"];

var tech = ['drones', 'an online platform', 'blockchain', 'web sockets', 'smartphones', 'instant messaging', 'social media', 'photography', 'Web RTC', 'an API', 'the internet of things', 'VR', 'AR', 'graphs', 'the internet', 'a Raspberry Pi', 'encryption', 'bitcoin', 'chatbots', 'geolocation', "an accelerometer", "machine learning", "SMS", "a Twitter bot", "an image recognition API"];



/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjRkFGQUZBIiB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xNjY0IDg5NnEwIDI1MS0xNDYuNSA0NTEuNXQtMzc4LjUgMjc3LjVxLTI3IDUtMzkuNS03dC0xMi41LTMwdi0yMTFxMC05Ny01Mi0xNDIgNTctNiAxMDIuNS0xOHQ5NC0zOSA4MS02Ni41IDUzLTEwNSAyMC41LTE1MC41cTAtMTIxLTc5LTIwNiAzNy05MS04LTIwNC0yOC05LTgxIDExdC05MiA0NGwtMzggMjRxLTkzLTI2LTE5Mi0yNnQtMTkyIDI2cS0xNi0xMS00Mi41LTI3dC04My41LTM4LjUtODYtMTMuNXEtNDQgMTEzLTcgMjA0LTc5IDg1LTc5IDIwNiAwIDg1IDIwLjUgMTUwdDUyLjUgMTA1IDgwLjUgNjcgOTQgMzkgMTAyLjUgMThxLTQwIDM2LTQ5IDEwMy0yMSAxMC00NSAxNXQtNTcgNS02NS41LTIxLjUtNTUuNS02Mi41cS0xOS0zMi00OC41LTUydC00OS41LTI0bC0yMC0zcS0yMSAwLTI5IDQuNXQtNSAxMS41IDkgMTQgMTMgMTJsNyA1cTIyIDEwIDQzLjUgMzh0MzEuNSA1MWwxMCAyM3ExMyAzOCA0NCA2MS41dDY3IDMwIDY5LjUgNyA1NS41LTMuNWwyMy00cTAgMzggLjUgODl0LjUgNTRxMCAxOC0xMyAzMHQtNDAgN3EtMjMyLTc3LTM3OC41LTI3Ny41dC0xNDYuNS00NTEuNXEwLTIwOSAxMDMtMzg1LjV0Mjc5LjUtMjc5LjUgMzg1LjUtMTAzIDM4NS41IDEwMyAyNzkuNSAyNzkuNSAxMDMgMzg1LjV6Ii8+PC9zdmc+"

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjRkFGQUZBIiB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xNDkwIDE0MjZ2LTY0OGgtMTM1cTIwIDYzIDIwIDEzMSAwIDEyNi02NCAyMzIuNXQtMTc0IDE2OC41LTI0MCA2MnEtMTk3IDAtMzM3LTEzNS41dC0xNDAtMzI3LjVxMC02OCAyMC0xMzFoLTE0MXY2NDhxMCAyNiAxNy41IDQzLjV0NDMuNSAxNy41aDEwNjlxMjUgMCA0My0xNy41dDE4LTQzLjV6bS0yODQtNTMzcTAtMTI0LTkwLjUtMjExLjV0LTIxOC41LTg3LjVxLTEyNyAwLTIxNy41IDg3LjV0LTkwLjUgMjExLjUgOTAuNSAyMTEuNSAyMTcuNSA4Ny41cTEyOCAwIDIxOC41LTg3LjV0OTAuNS0yMTEuNXptMjg0LTM2MHYtMTY1cTAtMjgtMjAtNDguNXQtNDktMjAuNWgtMTc0cS0yOSAwLTQ5IDIwLjV0LTIwIDQ4LjV2MTY1cTAgMjkgMjAgNDl0NDkgMjBoMTc0cTI5IDAgNDktMjB0MjAtNDl6bTE3NC0yMDh2MTE0MnEwIDgxLTU4IDEzOXQtMTM5IDU4aC0xMTQycS04MSAwLTEzOS01OHQtNTgtMTM5di0xMTQycTAtODEgNTgtMTM5dDEzOS01OGgxMTQycTgxIDAgMTM5IDU4dDU4IDEzOXoiLz48L3N2Zz4="

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjRkFGQUZBIiB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xNjg0IDQwOHEtNjcgOTgtMTYyIDE2NyAxIDE0IDEgNDIgMCAxMzAtMzggMjU5LjV0LTExNS41IDI0OC41LTE4NC41IDIxMC41LTI1OCAxNDYtMzIzIDU0LjVxLTI3MSAwLTQ5Ni0xNDUgMzUgNCA3OCA0IDIyNSAwIDQwMS0xMzgtMTA1LTItMTg4LTY0LjV0LTExNC0xNTkuNXEzMyA1IDYxIDUgNDMgMCA4NS0xMS0xMTItMjMtMTg1LjUtMTExLjV0LTczLjUtMjA1LjV2LTRxNjggMzggMTQ2IDQxLTY2LTQ0LTEwNS0xMTV0LTM5LTE1NHEwLTg4IDQ0LTE2MyAxMjEgMTQ5IDI5NC41IDIzOC41dDM3MS41IDk5LjVxLTgtMzgtOC03NCAwLTEzNCA5NC41LTIyOC41dDIyOC41LTk0LjVxMTQwIDAgMjM2IDEwMiAxMDktMjEgMjA1LTc4LTM3IDExNS0xNDIgMTc4IDkzLTEwIDE4Ni01MHoiLz48L3N2Zz4="

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEyNSIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTAwIDEwMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHBhdGggZD0iTTIwLjEsNjguMTFDMTUuNDg3LDcxLjk5OSw2LjIxLDc5LjMwMSwyLDgyLjU5M2M3LjQxOSw2LjY2NSwxNi45MTksMTEuMTU2LDI3LjU5LDEyLjMzICBjMjcuMTI4LDIuOTg2LDUxLjU0LTE2LjU4NCw1NC41MjUtNDMuNzExYzAuNDY0LTQuMjE2LDAuNDkxLTguODU3LTAuMDY1LTEzLjQ3M2wxMS4xOTEtOC45NzNMODEuNjMsMjcuMjY5bDAuMDAyLDAuMDE2ICBjLTIuNjU4LTcuMzYzLTcuMzcxLTEzLjY0Ni0xNC45MTQtMTYuNjA1Yy0xMS41ODItNC41NC0yNi4wMDksMy45NjUtMjcuNDMsMTYuODc2Yy0wLjczOCw2LjcxOCwxLjgzNiwxMy4wMzYsNi40MTYsMTcuMzI1ICBMMTYuMzQxLDIwLjQ0M0MxNi4zNDEsMjAuNDQzLTIuNDkyLDQ2Ljg2NywyMC4xLDY4LjExeiBNNTcuMDkxLDI3Ljk2NmMwLjI4OS0yLjYyNSwyLjY1LTQuNTE3LDUuMjczLTQuMjI5ICBjMi42MjEsMC4yODksNC41MTUsMi42NDksNC4yMjcsNS4yNzNjLTAuMjg5LDIuNjIzLTIuNjUsNC41MTYtNS4yNzMsNC4yMjdTNTYuODAyLDMwLjU4OSw1Ny4wOTEsMjcuOTY2eiIvPjwvc3ZnPg=="

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(83)

var Component = __webpack_require__(40)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(90),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 90:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "idea-container"
  }, [_c('div', {
    staticClass: "idea"
  }, [_c('a', {
    attrs: {
      "href": _vm.twitterIntent,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.twitterLogo
    }
  })]), _c('p', {
    attrs: {
      "id": "idea"
    }
  }, [_c('span', [_vm._v("Build something that uses ")]), _c('span', {
    staticClass: "data tech"
  }, [_vm._v(_vm._s(_vm.tech) + " ")]), _c('span', [_vm._v("to help ")]), _c('span', {
    staticClass: "data job"
  }, [_vm._v(" " + _vm._s(_vm.job))]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "data action"
  }, [_vm._v(" " + _vm._s(_vm.action))])]), _c('button', {
    style: (_vm.btnstyle),
    on: {
      "click": _vm.mixup
    }
  }, [_vm._v("Give Me an Idea!")])])])
},staticRenderFns: []}

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('a', {
    staticClass: "brand",
    attrs: {
      "href": _vm.home
    }
  }, [_c('h1', [_vm._v("Idea Mash")])]), _c('div', {
    staticClass: "app-container"
  }, [_c('Idea')], 1), _c('footer', [_c('div', {
    staticClass: "credits-container"
  }, [_c('div', {
    staticClass: "lg-credits"
  }, [_c('p', [_vm._v("Built by "), _c('a', {
    attrs: {
      "href": _vm.mccallLink,
      "target": "_blank"
    }
  }, [_vm._v("McCall Alexander")]), _c('br')]), _c('div', {
    staticClass: "social"
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/mccallalexander/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgs.insta
    }
  })]), _c('a', {
    attrs: {
      "href": "https://github.com/mccallofthewild/ideamash/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgs.gh
    }
  })]), _c('a', {
    attrs: {
      "href": "https://twitter.com/mccallthetall",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgs.twitter
    }
  })])]), _c('p')]), _c('div', {
    staticClass: "sml-credits"
  }, [_c('p', [_vm._v("Credits:")]), _c('span', [_vm._v("fingers crossed cursor:"), _c('a', {
    attrs: {
      "href": _vm.stefanLink,
      "target": "_blank"
    }
  }, [_vm._v(" Stefan Wetterstrand;")])]), _c('span', [_vm._v("twitter logo:"), _c('a', {
    attrs: {
      "href": _vm.audreyLink,
      "target": "_blank"
    }
  }, [_vm._v("Andrey Vasiliev;")])]), _c('span', [_vm._v("favicon:"), _c('a', {
    attrs: {
      "href": _vm.michalLink,
      "target": "_blank"
    }
  }, [_vm._v("Michal Beňo")])]), _c('span', [_c('a', {
    attrs: {
      "href": _vm.nounProjLink,
      "target": "_blank"
    }
  }, [_vm._v("The Noun Project")])])])])])])
},staticRenderFns: []}

/***/ })

},[45]);


// WEBPACK FOOTER //
// static/js/app.74c92f1d81db685b3ff5.js